import { styled, Grid, Typography, WithTheme } from '@material-ui/core'
import { Upload } from 'shared/icons'
import { Button as BaseButton } from 'shared/components'

interface DropWrapperProps extends WithTheme {
  disabled?: boolean
  loading?: boolean
}

const BUTTON_HEIGHT = 40

export const LOADER_SIZE = 75
export const LOADER_THICKNESS = 3

export const CLOSE_BTN_OFFSET = 15
export const CLOSE_BTN_SIZE = 28

export const UploadIcon = styled(Upload)(({ theme }) => ({
  color: theme.palette.primary.main,
  marginRight: theme.spacing(1.8),
}))

export const DropTitle = styled(Typography)({
  fontSize: 20,
  fontWeight: 400,
  lineHeight: '23.5px',
})

export const DropHint = styled(Typography)(({ theme }) => ({
  '&:first-child': {
    marginTop: theme.spacing(1.2),
  },
  fontSize: 16,
  fontWeight: 300,
  lineHeight: '19px',
}))

export const DropHintBold = styled('span')({
  fontSize: 'inherit',
  fontWeight: 500,
})

export const DropWrapper = styled(Grid)(
  ({ theme, disabled, loading }: DropWrapperProps) => ({
    boxSizing: 'border-box',
    borderWidth: 1,
    position: 'relative',
    borderRadius: 10,
    padding: theme.spacing(3.6, 0, 3.2),
    cursor: loading ? 'auto' : 'pointer',
    ...(disabled
      ? {
          borderColor: theme.palette.text.disabled,
          backgroundColor: theme.palette.grey[500],
          borderStyle: 'solid',
          cursor: 'auto',
        }
      : {
          borderColor: theme.palette.primary.main,
          borderStyle: 'dashed',
        }),
  })
)

export const Subtitle = styled(Typography)({
  fontSize: 18,
  fontWeight: 400,
  lineHeight: '26px',
})

export const HighlightedText = styled('span')(({ theme }) => ({
  fontSize: 'inherit',
  fontWeight: 700,
  color: theme.palette.primary.main,
  cursor: 'pointer',
}))

export const Button = styled(BaseButton)({
  fontSize: 16,
  lineHeight: '19px',
  fontWeight: 600,
  height: BUTTON_HEIGHT,
})

export const MaxFilesTitle = styled(Typography)(({ theme }) => ({
  fontSize: 20,
  fontWeight: 500,
  lineHeight: '23px',
  color: theme.palette.text.disabled,
}))
